// "View" on an upload tile: opens the document in a new tab, whether it is a file just
// chosen in the form (not uploaded yet) or one already stored on the server.
export default {
  methods: {
    viewDocument(field) {
      const file = this[field];
      if (!file) return;
      if (typeof file === "string") {
        window.open(this.mediaURL + file, "_blank");
        return;
      }
      const url = URL.createObjectURL(file);
      window.open(url, "_blank");
      // give the new tab time to load it before the address is released
      setTimeout(() => URL.revokeObjectURL(url), 5 * 60 * 1000);
    },
  },
};
